import { BCMSStateManagerCRUD, BrandingImage, BrandingStyle, CCTM, CCTM_demo, CCTM_item, CCTM_items, CCTM_link, CCTM_route, Link, StateManager, useCCTM, useModel, useRoute, useStateManager } from "@bcm-dev/bcms-vite";
import PageContainer from "components/shared/containers/PageContainer";
import { UIPrimaryButton, UISecondaryButton } from "components/ui/UIButton";
import UIPasswordInput from "components/ui/UIPasswordInput";
import UITextInput from "components/ui/UITextInput";
import UIToggle from "components/ui/UIToggle";
import React, { useEffect, useState } from "react";
import { ImageAsset } from "res";
import FaceIDView from "./components/FaceIDView";
import FastBalancesSetupView from "./components/FastBalancesSetupView";
import LoginFooter from "./components/LoginFooter";
import { LoginNavigation } from "./components/LoginNavigation";

import ABI22PageIframeView from "components/shared/views/ABI22PageIframeView";
import LoginWrapper from "components/shared/wrappers/LoginWrapper";
import "./styles.css";

/**
 * @function LoginPage
 * @exported true
 * @description This is the login page.
 * @return {React.Component}
 */
export default function LoginPage(props) {
  // Set the data and ui variables with the default values and whats passed
  // through the properties
  const data = { ...getDefaultPageData(), ...props.data ?? {} };
  const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

  // The state that will be passed to the state manager
  const state = { data, ui };
  // :: React.state, React.setState -> OBJECT
  // Function that returns the controller for the state manager
  const controller = (state, setState) => ({
      data: state.data, // Set the data property in the controller
      ui: state.ui, // Set the ui property in the controller 

      // onEventChange :: STRING, * -> VOID
      // Update the data based on the passed prop and value parameters
      onEventChange: prop => value => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", prop ], value)
        .submit(setState);
      },
  });

  return (
    <StateManager state={ state } controller={ controller }>
      <LoginContent/>
    </StateManager>
  );
}

/**
 * @name getDefaultPageData
 * @returns {OBJECT}
 * @description Hook to return the default data that the pages needs
 */
export const getDefaultPageData = () => ({
  userID: "DemoUser",
  password: "123456789",
  userIDValOnChange: "DemoUser",
  passwordValOnChange: "123456789",
  saveUserIDToggleOn: false,
  revealPassword: false
});

/**
* @name getDefaultPageUI
* @returns {OBJECT}
* @description Hook to return the default ui that the page needs
*/
export const getDefaultPageUI = () => ({
  showFastBalancesSetupView: false,
});

function MenuWrapper(props){
  console.log("wrapper")
  return<>
    {props.children}
  </>
}
function MenuLinks(props){

  const text = props.label ?? "[text]";
  let to = props.to ?? "";
  const icon = props.asset_name ?? false;
  const className = props["custom-class"]? { "className":  props["custom-class"] } : {};
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};
  let onClick = ()=>{};
  if(props.onClick){
      to = "";
      onClick= props.onClick;
  }
return <Link to={to} {...dataPoint} onClick={onClick} {...className}>{text}</Link>   
}
/**
 * @name LoginContent
 * @returns {React.Component}
 * @description Content component for the login page
 */
function LoginContent(props) {
  const { data, ui, onEventChange } = useStateManager();
  const route = useRoute();
  const onFastBalancesButtonClick = () => route("/noFooter/loginFastBalancesWorkflow");
  const loginButtonIsEnabled = data.userIDValOnChange !== "" && data.passwordValOnChange !== "";
  const { b, branding } = useModel();
  const course = branding.options.abi22_courseid_mabi23;
  const [ src ] = useState({ key: Date.now() });
  const origin =  window.location.origin.indexOf("localhost") !== -1 ? `http://${window.location.hostname}:${parseInt(window.location.port)+1}` : window.location.origin+`${window.location.pathname.replace("mabi23","abi22")}?b=${ b }&c=${ course }`;
  
  // abi22 branding needs to be used in this page.
  const [ didLoadPlaceholderABI22, setDidLoadPlaceholderABI22 ] = useState(window.abi22Branding ? true : false);

  const abi22Branding = window.abi22Branding ?? {};
  const abi22FDICLogoAndDisclaimer = abi22Branding.options ? abi22Branding.options.fdic_abi22 : "";
let mabi23FDICLogoAndDisclaimer = branding.options.fdic_mabi23??abi22FDICLogoAndDisclaimer;
 
const xml =  useCCTM(),
            leftMenu= <CCTM nav-id={"loginLeftWidgetLinks"} xml={xml} self={MenuWrapper}>
                                                 
                        <CCTM_route component={MenuLinks}/>                  
                        <CCTM_link component={MenuLinks}/> 
                        <CCTM_item component={MenuLinks}/>   
                        <CCTM_items component={MenuLinks} />                     
                        <CCTM_demo component={MenuLinks}/>                                 
                    </CCTM>,
          rightMenu= <CCTM nav-id={"loginRightWidgetLinks"} xml={xml} self={MenuWrapper}>                              
          <CCTM_route component={MenuLinks}/>                  
          <CCTM_link component={MenuLinks} /> 
          <CCTM_item component={MenuLinks} />   
          <CCTM_items component={MenuLinks}/>                     
          <CCTM_demo component={MenuLinks} /> 
                  
           </CCTM>;          

  // "useEffect" code here is primary used to handle postMessages from child iframes.
  useEffect(() => {
    const abi22IframeDidLoad = evt => {
    
      if(evt.data.message === "abi22-iframe-did-load") {
        const branding = evt.data.abi22Branding ?? {};
      
        window.abi22Branding = branding;
        setDidLoadPlaceholderABI22(true);
      }
    };

    // Set an attribute on the root element
    // indicating that abi22 successfully loaded.
    if(didLoadPlaceholderABI22) {
      document.getElementById("root").setAttribute("abi22-did-load", "true");
    }

    window.addEventListener("message", abi22IframeDidLoad);

    return () => {
      window.removeEventListener("message", abi22IframeDidLoad);
    };
  });
 
  return (
    <>
    {/* This code will load a placeholder abi22 in order to get the branding in abi22.
    After loading abi22, mabi22 content will be shown with additional abi22 branding.
    "Loading model" is shown in order to mimic the bcms "Loading model" message while abi22 loads. */}
    { !didLoadPlaceholderABI22 && 
    <>
      <h3 className="loading-model-message">Loading Model...</h3>
      <ABI22PageIframeView className="hide" srcKey={ src.key } src= { `${ origin }/#/` } />
    </> 
    }
    { didLoadPlaceholderABI22 && <LoginWrapper>
    <PageContainer className={ `login-page flex-container flex-vertical` } noWrapper={props.noWrapper}>
      <BrandingStyle className={ `flex-height flex-container flex-vertical align-center background-image` } style={{
        "backgroundColor" : "login_bg_mabi23",
        "backgroundImage" : "url([[login_bg_image_mabi23]])"
      }}>
            <div className="fi-fdic-container flex-height flex-container align-center">
              <div className="fi-fdic-logos">
                <div className="logo-container  flex-container align-center">
                  <BrandingImage id="fi_logo_mabi23" className="logo" alt="Financial Institutions Logo" />
                </div>
                {mabi23FDICLogoAndDisclaimer === "Colored (White BG)" && didLoadPlaceholderABI22 &&
                  <div className="fdic-logo-container">
                    <ImageAsset id="FDICDigitalSign" className="logo" />
                  </div>
                }
                {mabi23FDICLogoAndDisclaimer === "White (Dark BG)" && didLoadPlaceholderABI22 &&
                  <div className="fdic-logo-container">
                    <ImageAsset id="FDICDigitalSignWhite" className="logo" />
                  </div>
                }
              </div>

            </div>

        <div className="fast-balances-button-container set-height text-center">
          <UISecondaryButton text="Fast Balances" dataPoint="Fast_Balances_Label" onClick={ onFastBalancesButtonClick } />
        </div>
        <div className="login-content-container black-transparent-background set-height flex-container flex-vertical space-around">
          <FaceIDView />
          { ui.showFastBalancesSetupView &&
          <FastBalancesSetupView />
          }
          <div className="login-input-container flex-container flex-vertical flex-height">
            <div className="flex-height user-id-input">
              <UITextInput placeholder="User ID" value={ data.userID } readOnly="true" onChange={ onEventChange("userIDValOnChange") } onBlur={ onEventChange("userID") } dataPoint="User_ID_Input"/>
            </div> 
            <div className="flex-height password-input">
              <UIPasswordInput readOnly="true" revealPassword={ data.revealPassword } disabledRevealPasswordOnClick="true" placeholder="Password" value={ data.password } onChange={ onEventChange("passwordValOnChange") } onBlur={ onEventChange("password") } dataPoint="Password_Input" />
            </div>
          </div>
          <div className="button-container set-height flex-container flex-vertical justify-center">
            <div className="flex-container flex-horizontal flex-height bottom-items">
              <div className="flex-container flex-vertical flex-width">
                 
                { !ui.showFastBalancesSetupView &&
                <div className="flex-width flex-container flex-horizontal align-center">
                  <UIToggle checked={ data.saveUserIDToggleOn } dataPoint="Save_User_ID_Toggle" />
                  <label className="toggle-label">Save User ID</label>
                </div>
                }
                  {leftMenu}
              </div>
           
              <div className="flex-width flex-container flex-vertical align-bottom">
                <UIPrimaryButton className={ loginButtonIsEnabled ? "" : "disabled" } text="Log in" 
                onClick={(evt)=>{route("/noFooter/mabi23FirstTimeLogin")}} dataPoint="Login_Button"/>
               
              
                 {rightMenu}
              
               
               
                
              </div>
            </div>
          </div>
        </div>
        <LoginNavigation />
        <LoginFooter />
      </BrandingStyle>
    </PageContainer>
    
     
  </LoginWrapper> }
    </>

    
  );
}